import type { ComponentProps } from 'react'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from './CommandModalButton'
import { CommandModalDataFallbackForm } from './CommandModalDataFallbackForm'
import type { ActionButtonProps } from './types'

export const InvoicesCommandModalButtonFallback = (
  props: ActionButtonProps,
) => {
  const { tenantId, invoiceId } = useHook('routing.invoice.useInvoiceParams')()

  const actions = useHook('mutators.moneyIn.useInvoiceCommandFallbackActions')({
    invoiceId,
    tenantId,
    ...props,
  })

  const submit = useVariantAction({
    ...props,
    actions,
  })

  const commandData = props.eventVersionWithCommand?.commandVersion?.commandData

  const actionId = `moneyIn.${commandData?._type}`

  return props.commandActionVariant === 'create' ? null : (
    <CommandModalButton
      actionId={
        actionId as ComponentProps<typeof CommandModalButton>['actionId']
      }
      // Translations here will be looked at in a later PR: APG2223-3986
      title={commandData?._type ?? ''}
      commandDataForm={CommandModalDataFallbackForm}
      submit={submit}
      {...props}
    />
  )
}
